/*
Standardized component for uploading, deleting and retrieving uploaded files stored as Blob data in the database.
Must be contained within a grid column as so, note the <ng-template> nodes:

		              <aims-common-table-dynamic-row id="attachment">
                    <ng-template viewMode let-element >
                      <aims-grid-upload [dataItem]="dataItem"
                        saveUrl="Logistics/SaveCommentAttachment"
                        primaryKeyName="commentId"
                        (success)="loadReq(reqHeader.reqId)"
                      ></aims-grid-upload>
                    </ng-template>
                    <ng-template editMode let-element>
                      <aims-grid-upload-display [dataItem]="dataItem"
                        deleteUrl="Logistics/DeleteCommentAttachment"
                        primaryKeyName="commentId"
                        loadUrl="Logistics/DisplayCommentAttachment"
                        fileNameColumnName="attachmentName"
                        [editable]="editable"
                        (deleteComplete)="loadReq(reqHeader.reqId)"
                      ></aims-grid-upload-display>
                    </ng-template>
                  </aims-common-table-dynamic-row>

The controller method must return a File()
See the Logistics methods referenced above for Controller code example

*/



import { Component, OnInit, Input, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { TransferHttpService } from '../../../../src/app/services/transfer-http/transfer-http.service';
import { take } from 'rxjs/operators';
import { environment } from '../../../../src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'aims-grid-upload-display',
  styleUrls: ['./aims-grid-upload.component.css'],
  templateUrl: './aims-grid-upload-display.html'
})
export class AimsGridUploadDisplayComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  @Input() dataItem: any;
  @Input() loadUrl: string;
  @Input() fileNameColumnName: string;
  @Input() primaryKeyName: string;
  @Input() deleteUrl: string;
  @Input() editable: boolean;

  @Output() deleteComplete = new EventEmitter();

  m = UpMethods;

  downloadFile(clickEvent) {
    if (isPlatformBrowser(this.platformId)) {
      clickEvent.stopPropagation();
      this.transferHttp.get(`${this.loadUrl}?${this.primaryKeyName}=${this.dataItem[this.primaryKeyName]}`, { responseType: 'arraybuffer' })
        .pipe(take(1))
        .subscribe(response => {
          let dataType = response.type;
          let binaryData = [];
          binaryData.push(response);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (this.dataItem[this.fileNameColumnName])
            downloadLink.setAttribute('download', this.dataItem[this.fileNameColumnName]);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          downloadLink.parentNode.removeChild(downloadLink);
        });
    }
  }

  public uploadRemove(clickEvent) {
    if (isPlatformBrowser(this.platformId)) {
      clickEvent.stopPropagation();
      //This is a post since it doesn't delete the line from the database
      this.transferHttp.post(`${this.deleteUrl}?${this.primaryKeyName}=${this.dataItem[this.primaryKeyName]}`, null).pipe(take(1)).subscribe(() => {
        this.deleteComplete.emit(true);
      });
    }
  }

  ngOnInit() {
  }

}


@Component({
  selector: 'aims-grid-upload',
  templateUrl: './aims-grid-upload.component.html',
  styleUrls: ['./aims-grid-upload.component.css']
})
export class AimsGridUploadComponent implements OnInit {

  @Input() dataItem: any;
  @Input() primaryKeyName: string;
  @Input() saveUrl: string;

  @Input() fileRestrictions: string = ".jpg, .png, .pdf";
  @Input() maxFileSize: 4194304;


  @Output() success = new EventEmitter();

  constructor(private transferHttp: TransferHttpService) { }

  env = environment;
  m = UpMethods;

  ngOnInit() {
  }

}

class UpMethods {
  static alreadyExists(dataItem: any, primaryKeyName: string): boolean {
    if (dataItem[primaryKeyName] > 0)
      return true;
    else
      return false;
  }
}

